import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef, DialogService } from '@ngneat/dialog';

@Component({
  selector: 'app-modal-customization-forbidden',
  templateUrl: './modal-customization-forbidden.component.html',
  styleUrls: ['./modal-customization-forbidden.component.scss']
})
export class ModalCustomizationForbiddenComponent implements OnInit {

  constructor(private router: Router, private dialog: DialogService, public ref: DialogRef) { }

  ngOnInit(): void {
  }

  signIn() {
    this.router.navigate(['/signin']);
    this.closeModal();
    this.dialog.closeAll();
  }

  closeModal() {
    this.ref.close();
  }
}
